import React from 'react'
import resources from '../../../services'
import DataTable from '../../../composents/DataTable'
import MainPage from '../../../composents/MainPage'

const title = 'Consumptions'
const headers = {
  icon: 'feather icon-credit-card',
  title: title,
  description: 'track and manage all consumptions information',
}

export default function ConsumptionPage() {
  return (
    <MainPage headers={headers} show_search>
      <DataTable
        column={[
          {
            label: 'Consumer ',
            field: 'user',
            render: ['surname'],
          },
          {
            label: 'Consumption',
            field: 'consumption',
          },
          {
            label: 'Card number',
            field: 'card',
            render: ['cardNumber'],
          },
          // {
          //   label: 'Zone',
          //   field: 'zone',
          //   render: ['zone'],
          // },
          {
            label: 'Meter',
            field: 'meter',
            render: ['code'],
          },

          {
            label: 'Date ',
            field: 'dateUse',
            isDate: true,
          },
          {
            label: 'Time ',
            field: 'timeUse',
            isTime: true,
          },
        ]}
        resource={resources.consumption}
        title={title}
        update={false}
        deleteItem={false}
        show_btn={false}
        link="/water_cards/countries"
      />
    </MainPage>
  )
}
